/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import clsx from "clsx";

function BASEPageSimpleHeader(props) {
  return (
    <div className={clsx("BASEPageSimple-header", props.className)}>
      <div className="container">{props.header && props.header}</div>
    </div>
  );
}

export default BASEPageSimpleHeader;
